// src/pages/health/WorkoutGuideVideo.jsx (기존 WorkoutGuideVideo 파일)
import { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthCard from "../../../../components/auth/AuthCard";
import BottomNav from "../../../../components/common/BottomNav";
import { useLoadingGate } from "../../../../hooks/useLoadingGate";
import { TITLES, VIDEOS_BY_ITEM } from "../../../../data/videos/workoutVideos";

export default function WorkoutGuideVideo({ machineGuide = false }) {
    const ready = useLoadingGate();
    const navigate = useNavigate();
    const [sp] = useSearchParams();

    const cat = machineGuide ? "machine" : sp.get("cat") || "tool";
    const itemKey = machineGuide ? "machine" : sp.get("item") || "functional";

    const title = TITLES[itemKey] || TITLES[cat] || "피트니스 운동 영상";

    const list = useMemo(
        () => VIDEOS_BY_ITEM[itemKey] || [],
        [itemKey]
    );

    return (
        <main className="h-[var(--app-height)] flex flex-col font-suit overflow-y-auto scrollbar-hide px-7 md:px-8 bg-white">
            {!ready ? (
                <div className="flex-1" />
            ) : (
                <AuthCard
                    className="flex-1 w-full mx-auto"
                    title={title}
                    onClose={() => navigate(-1)}
                >
                    <div className="flex flex-col flex-1 pt-3 md:pt-4 pb-24 md:pb-28">
                        <ul className="grid grid-cols-2 gap-3 md:gap-4 rounded-2xl">
                            {list.map((v) => (
                                <li key={v.id}>
                                    <button
                                        type="button"
                                        className="w-full rounded-2xl bg-white transition"
                                        onClick={() => {
                                            navigate(
                                                `/workout/workoutguide/video/detail?v=${encodeURIComponent(
                                                    v.id
                                                )}&item=${encodeURIComponent(
                                                    itemKey
                                                )}&cat=${encodeURIComponent(cat)}`
                                            );
                                        }}
                                    >
                                        {v.thumb ? (
                                            <img
                                                src={v.thumb}
                                                alt={v.title}
                                                className="aspect-video w-full object-cover rounded-xl"
                                            />
                                        ) : (
                                            <div className="aspect-video w-full border border-gray-200" />
                                        )}
                                        <div className="px-3 py-2">
                                            <p className="text-sm md:text-base font-medium leading-tight line-clamp-2 text-center">
                                                {v.title}
                                            </p>
                                        </div>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </AuthCard>
            )}

            <BottomNav className="h-16 md:h-[72px]" />
        </main>
    );
}
